module.exports = __webpack_public_path__ + "img/87.68fa8360.jpg";